import moment from "moment";
import { useRef } from "react";
import { Card, Col, Jumbotron, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import CardDataClientColombia from "./CardDataClientColombia";
import CardDataClientMexico from "./CardDataClientMexico";

function DoctorCitaNoComienzaDiferentDay({t, messageCita,cita, companyType, handleShowEditData, setShowSuccess, setShowModalServer, setErrorServer, handleShowEditDataMexico, ondemand, noComienza}){
    const scrollRef = useRef()

    return(
        <Row>
            <Col xs="12" md="6" className="overflow-y-auto h-scrollbar h-100vh order-2 order-md-1" ref={scrollRef}>
                <Card className="shadow-1 bg-blue-light my-3">
                    <Card.Body>
                        <div className="d-flex justify-content-between">
                            <div>
                                <h6 className="mb-0 text-blue-2">{t('cita_comienza')}</h6>
                            </div>
                            <div>
                                <h6 className="mb-0 text-blue-2">
                                    {moment(cita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD MMMM YYYY HH:mm")}
                                </h6>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
                {
                    !ondemand ?
                    <>
                        {
                            companyType==='colombia' ? 
                            <CardDataClientColombia cita={cita} handleShowEditData={handleShowEditData} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer} noComienza={noComienza}/> : 
                            <CardDataClientMexico cita={cita} setShowSuccess={setShowSuccess} handleShowEditDataMexico={handleShowEditDataMexico} setShowModalServer={setShowModalServer} setErrorServer={setErrorServer} noComienza={noComienza}/>
                        }
                    </> :
                    <>
                        <Jumbotron>
                            <p className="text-center">Espere a que la cita comience</p>
                        </Jumbotron>
                    </>
                }
                
            </Col>
            <Col xs="12" md="6" className="order-1 order-md-2">
                <Jumbotron className="my-3">
                    <h3 className="text-center">{messageCita}</h3>                        
                </Jumbotron>
            </Col>
        </Row>
    )

}

export default withTranslation()(DoctorCitaNoComienzaDiferentDay)